import { useMutation, useQueryClient } from '@tanstack/react-query'

import { integrationsKeys } from 'common/api/queryKeys/integrationsKeys'
import { errorToast, successToast } from 'common/components/toastNotification'

import { updateIntegration } from '../api'

const useUpdateIntegrationMutation = (accountId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateIntegration,
    onSuccess: async () => {
      successToast('The integration has been successfully updated', {
        autoClose: 3000,
      })
      queryClient.invalidateQueries({
        queryKey: integrationsKeys.accounts(accountId),
      })
    },
    onError: () => {
      errorToast('The integration could not be updated', { autoClose: 3000 })
    },
  })
}

export default useUpdateIntegrationMutation
